// extracted by mini-css-extract-plugin
module.exports = {"aspect":"WithAspect_aspect__AGkXX","aspect-content":"WithAspect_aspect-content__y_VQv"};